import type { Playlist } from '@24i/nxg-sdk-photon';
import { getRuntimeConfig } from '@24i/nxg-sdk-smartott/src/Application/initApp';
import { useQuery, UseQueryOptions } from 'react-query';
import { usePurchaseData } from '@24i/nxg-sdk-smartott-shared/src/context/PurchaseData';
import { queryKeys } from '../queryKeys';

const useMyExpiredRentalsQuery = (options?: UseQueryOptions<Playlist>) => {
    const { fetchMyExpiredRentals } = usePurchaseData();
    const reactQuery = getRuntimeConfig('reactQuery');

    return useQuery<Playlist>(queryKeys.myExpiredRentals(), fetchMyExpiredRentals, {
        staleTime: reactQuery.staleTime.short,
        ...options,
    });
};

export default useMyExpiredRentalsQuery;
